<template>
  <v-row style="max-height: 60px;" class="mb-2 mt-2">
    <v-col cols="3" style="margin-left: auto;" class="ma-0 pt-0">
      <v-autocomplete
        v-model="providerSettingConfiguration.parentPath"
        :items="modelFields"
        :label="$t('ValueType')"
        item-text="parentPath"
        item-value="parentPath"
        @change="setFieldsForParent()"
        :disabled="item.disabled"
        clearable
        ></v-autocomplete>
    </v-col>
    <v-col  class="ma-0 pt-0">
      <v-text-field :disabled="!isSelectedParentPathAnArray"
                    @change="setNewConfigForField()"
                    v-model="providerSettingConfiguration.index"
                    label="index"
                    type="number"
                    min="0"
                    max="255">
      </v-text-field>
    </v-col>
    <v-col class="ma-0 pt-0">
      <v-autocomplete :disabled="!isSelectedParentPathAnArray"
                      v-model="providerSettingConfiguration.childPath"
                      :items="filteredChildFields()"
                      :label="$t('ValueType')"
                      item-text="childPath"
                      item-value="childPath"
                      @change="setTypeForChildren()"
                      clearable
                      :error-messages="childFieldErrors">
      </v-autocomplete>
    </v-col>
    <v-col class="ma-0 pt-0">
      <v-autocomplete v-model="providerSettingConfiguration.resultPath"
                      :items="filteredResultPaths"
                      :label="$t('ResultPathType')"
                      item-text="resultPath"
                      item-value="resultPath"
                      :disabled="!providerSettingConfiguration.parentPath"
                      @change="setNewConfigForField()"
                      clearable>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>
<script>

import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { ref } from "vue";

export default {
  name: "prebuiltsComponent",
  key: "prebuiltsComponent",
  components: {
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    modelFields: {
      type: Array,
      default: () => []
    },
    resultPaths: {
      type: Array,
      default: () => []
    },
    configObject: {
      type: Array,
      default: () => []
    }
  },
  created() {
    for (let c of this.configObject) {
      if (c.fieldCode === this.item.Code) {
        this.providerSettingConfiguration.parentPath =  c.parentPath;
        this.providerSettingConfiguration.index = c.index;
        this.providerSettingConfiguration.childPath = c.childPath;
        this.providerSettingConfiguration.resultPath = c.resultPath;

        let selectedModel = this.modelFields.find(field => field.parentPath === this.providerSettingConfiguration.parentPath);
        this.setOtherFieldsBasedOnSelectedParent(selectedModel);
        this.filterResultPathsForType();
      }
    }
  },
  data() {
    return {
      providerSettingConfiguration: {
        parentPath: null,
        childPath: null,
        index: null,
        resultPath: null
      },
      isSelectedParentPathAnArray: false,
      filteredResultPaths: [],
    };
  },
  watch: {
    configObject: {
      handler(config) {
        for (let c of config) {
          if (c.fieldCode === this.item.Code) {
            this.providerSettingConfiguration.parentPath =  c.parentPath;
            this.providerSettingConfiguration.index = c.index;
            this.providerSettingConfiguration.childPath = c.childPath;
            this.providerSettingConfiguration.resultPath = c.resultPath;
          }
        }
      },
      deep: true
    }
  },
  mixins: [validationMixin],
  validations: {
    providerSettingConfiguration: {
      childPath: {
        required: requiredIf(function () {
          return this.isSelectedParentPathAnArray;
        })
      }
    }
  },
  computed: {
    childFieldErrors() {
      const errors = [];
      if (!this.$v.providerSettingConfiguration.childPath.$dirty) return errors;
      !this.$v.providerSettingConfiguration.childPath.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    setFieldsForParent() {
      this.providerSettingConfiguration.index = null;
      this.providerSettingConfiguration.childPath = null;
      this.setNewConfigForField();

      if (this.isSelectedParentPathAnArray) {
        if (!this.providerSettingConfiguration.index) {
          this.providerSettingConfiguration.index = 0;
        }
      }


    },
    setNewConfigForField(){
      let selectedModel = this.modelFields.find(field => field.parentPath === this.providerSettingConfiguration.parentPath);

      let currentConfigForThisCode = {
        fieldCode: this.item.Code,
        parentPath: this.providerSettingConfiguration.parentPath,
        index: this.providerSettingConfiguration.index,
        childPath: this.providerSettingConfiguration.childPath,
        resultPath: this.providerSettingConfiguration.resultPath,
      };

      this.setOtherFieldsBasedOnSelectedParent(selectedModel);
      this.filterResultPathsForType();

      this.$emit('getFieldSetting', currentConfigForThisCode);
    },

    setOtherFieldsBasedOnSelectedParent(selectedModel) {
      this.isSelectedParentPathAnArray = selectedModel && selectedModel.children && selectedModel.children.length > 0;
      this.providerSettingConfiguration.type = selectedModel ? selectedModel.type : null;
    },

    filteredChildFields() {
      let fieldSelected = this.modelFields.find(field => field.parentPath === this.providerSettingConfiguration.parentPath);
      if (fieldSelected && fieldSelected.children && fieldSelected.children.length > 0)
        return fieldSelected.children;
    },

    filterResultPathsForType() {
      if (!this.providerSettingConfiguration.parentPath)
        return [];

      let validResults = [];

      let type = this.getTypeBasedOnParentChildrenCombination(this.providerSettingConfiguration.parentPath, this.providerSettingConfiguration.childPath);

      Object.entries(this.resultPaths[0]).forEach(([key, value]) => {
        if (key === type) {
          Object.entries(value).forEach(([innerKey, innerValue]) => {
            validResults.push(innerValue.property);
          });
        }
      });

      this.filteredResultPaths = validResults;
    },
    setTypeForChildren() {
      this.setNewConfigForField();
    },

    getTypeBasedOnParentChildrenCombination(parentPath, childPath) {
      let selectedModel = this.modelFields.find(field => field.parentPath === parentPath);

      if (!childPath) {
        return selectedModel.type
      }
      else {
        let childModel = selectedModel.children.find(t => t.childPath === childPath);

        return childModel.childType;
      }
    },

    validateFields() {
      this.$v.$touch(); // Esto activará las validaciones en el componente hijo
      if (!this.$v.$invalid) {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>
